import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';

import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { getLeadUid } from 'site-modules/shared/components/lead-form/utils/utils';
import { numberWithCommas } from 'site-modules/shared/utils/string';

import './card.scss';

export function DealerSimpleCard({ leadTarget, showVin = false, showPrice = false }) {
  const { dealer, inventory, leadAttributes } = leadTarget;

  const distance = get(leadAttributes, 'distance');
  const dealerInfo = get(inventory, 'dealerInfo', dealer);
  const vin = get(inventory, 'vin');
  const displayPrice = get(inventory, 'prices.displayPrice');

  const salesOverallRating = get(dealerInfo, 'displayInfo.salesOverallRating', get(dealerInfo, 'salesRating', 0));
  const salesReviewCount = get(dealerInfo, 'displayInfo.salesReviewCount', get(dealerInfo, 'salesReviewCount', 0));

  const uid = getLeadUid(leadTarget);

  return (
    <div>
      <div className="text-gray-darker heading-4 fw-normal" id={uid}>
        {dealerInfo.name}
      </div>
      <div className="small py-0_25">
        <RatingStars rating={salesOverallRating} className="text-primary-darker me-0_25" />
        <span>({salesReviewCount})</span>
      </div>
      {distance > 0 && <div className="small text-gray-dark">{distance.toFixed(1)} miles away</div>}
      {showPrice && !!displayPrice && (
        <div className="small text-gray-dark">Price: ${numberWithCommas(displayPrice)}</div>
      )}
      {showVin && vin && <div className="small text-gray-dark">VIN: {vin}</div>}
    </div>
  );
}

DealerSimpleCard.propTypes = {
  leadTarget: PropTypes.shape({
    inventory: PropTypes.shape({}),
    dealer: PropTypes.shape({}),
    leadAttributes: PropTypes.shape({
      primary: PropTypes.bool.isRequired,
      selected: PropTypes.bool.isRequired,
      distance: PropTypes.number,
    }).isRequired,
  }).isRequired,
  showVin: PropTypes.bool,
  showPrice: PropTypes.bool,
};
